import React from "react";
import "tailwindcss/tailwind.css";
import { Link } from "react-router-dom";
import aboutImage from "../assets/images/QuiSommeNous.png";

const Sommenous = () => {
  return (
    <div
      id="sommenous"
      className="relative flex items-center justify-center min-h-screen px-6 py-10 bg-white"
    >
      <div className="relative z-10 max-w-6xl w-full flex flex-col md:flex-row items-stretch gap-10">

        {/* Image gauche */}
        <div className="w-full md:w-1/2 h-full flex items-center justify-center">
  <img
    src={aboutImage}
    alt="J-Tronics"
    className="w-full max-h-[1100px] object-contain rounded-xl shadow-lg"
  />
</div>

        {/* Texte droite */}
        <div className="w-full md:w-1/2 text-gray-600 flex flex-col justify-center">

          {/* J-TRONICS avec ligne à gauche */}
          <div className="flex items-center gap-3 mb-3">
            <span className="w-8 h-[2px] bg-yellow-400 rounded-full" />
            <span className="text-sm font-semibold tracking-[0.25em] uppercase text-gray-400">
              J-Tronics
            </span>
          </div>

          {/* INNOVATION & PERFORMANCE */}
          <h1 className="text-2xl md:text-3xl font-black text-blue-600 uppercase leading-tight tracking-tight mb-3">
  Innovation &amp; Performance
</h1>

          {/* Votre partenaire */}
          <div className="flex items-center gap-2 mb-6">
            <span className="text-yellow-400 font-bold text-lg">—</span>
            <h2 className="text-base font-semibold text-yellow-500 tracking-wide uppercase">
              Votre partenaire de confiance
            </h2>
          </div>

          {/* Paragraphe */}
          <p className="text-base text-gray-500 leading-relaxed">
  J-Tronics, fondée en 2022 à Djebeniana (Sfax) par Mohamed Amine Hsouna, est une entreprise tunisienne spécialisée dans les systèmes de lavage self-service et automatiques. L’entreprise propose des solutions innovantes, performantes et durables, conçues pour répondre aux besoins de ses clients. Reconnue pour son esprit d’innovation, J-Tronics est une marque déposée auprès de l’INNORPI et titulaire d’un brevet d’invention enregistré. Grâce à son savoir-faire et à ses technologies modernes, l’entreprise contribue au développement du secteur du lavage en Tunisie et ambitionne de devenir une référence dans son domaine.


</p>
{/* Bouton En savoir plus */}
{/* Bouton En savoir plus */}
<div className="mt-6">
  <Link
    to="/qui-sommes-nous"
    className="inline-flex items-center px-6 py-2 border border-yellow-400 text-yellow-500 bg-white rounded-md transition duration-300 hover:bg-yellow-400 hover:text-white font-bold w-fit"
  >
    En savoir plus
  </Link>
</div>
        </div>

      </div>
    </div>
  );
};

export default Sommenous;